/*
 * @Author: wangyy
 * @Date: 2021-01-04 16:18:55
 * @LastEditTime: 2021-01-05 09:51:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \55.002\openplat-web-inner\src\utils\track.js
 */
const Track = {
  //设置用户信息
  setUserInfo: () => {
    // let token = "";
    // if (window.sessionStorage.getItem("Access-Token")) {
    //   token = window.atob(
    //     window.sessionStorage
    //       .getItem("Access-Token")
    //       .split(".")[1]
    //       .split(".")[0]
    //   );
    // }
    // let data = {
    //   c_userid: this.$store.getters.hsid
    // };
    // let timer = setInterval(() => {
    //   if (hssdk_click) {
    //     hssdk_click(data);
    //     clearInterval(timer);
    //   }
    // }, 100);
  }
};

export default Track;



// WEBPACK FOOTER //
// ./src/gtn/utils/track.js